import { ThemedSendMoney as SendMoney } from './send-money';
export const ThemedSendMoney = SendMoney;
